import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Coffee, Leaf, Moon, Pill } from 'lucide-react';
export function FailedSolutions() {
  const solutions = [{
    icon: <Coffee size={24} data-id="element-106" />,
    title: 'El café solo bloquea la señal',
    desc: "Bloquea la señal de cansancio, pero no recarga la 'pila' celular; de hecho, acelera la pérdida de minerales esenciales a través de la orina."
  }, {
    icon: <Leaf size={24} data-id="element-107" />,
    title: "Las dietas 'limpias' no bastan",
    desc: 'Son un gran paso, pero debido a los suelos empobrecidos de la agricultura moderna, es casi imposible obtener niveles óptimos de ciertos minerales solo con comida.'
  }, {
    icon: <Moon size={24} data-id="element-108" />,
    title: 'Dormir más no repara el daño',
    desc: "No repara el daño bioquímico si a tus mitocondrias les faltan los 'co-factores' necesarios para producir energía real (ATP)."
  }, {
    icon: <Pill size={24} data-id="element-109" />,
    title: 'Multivitamínicos genéricos',
    desc: 'Tienen baja bio-disponibilidad; tu cuerpo elimina el 90% antes de que lleguen a tu torrente sanguíneo. Estás tirando tu dinero.'
  }];
  return <section className="py-24 px-4 bg-sage" data-id="element-110">
      <div className="max-w-4xl mx-auto" data-id="element-111">
        <FadeIn data-id="element-112">
          <h2 className="font-serif text-3xl sm:text-4xl font-bold text-forest mb-12 text-center" data-id="element-113">
            Por qué lo que intentaste no funcionó
          </h2>
        </FadeIn>

        <div className="grid sm:grid-cols-2 gap-6" data-id="element-114">
          {solutions.map((item, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-115">
              <div className="bg-offwhite p-8 rounded-2xl shadow-sm h-full flex flex-col" data-id="element-116">
                <div className="w-12 h-12 bg-forest/10 rounded-full flex items-center justify-center mb-6 text-forest" data-id="element-117">
                  {item.icon}
                </div>
                <h3 className="font-bold text-xl mb-3 text-forest" data-id="element-118">
                  {item.title}
                </h3>
                <p className="text-charcoal/70 leading-relaxed flex-grow" data-id="element-119">
                  {item.desc}
                </p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}